import Vue from 'vue';
import store from "@/store";
import i18n from '@/language/i18n';

var uuid = require('uuid').v4;

export default {
    namespaced: true,
    state: {
        tasks: {},
    },
    mutations: {
        setTask(state, { taskId, callback, expiresAt, taskPayload }) {
            Vue.set(state.tasks, taskId, { callback, expiresAt, taskPayload });
        },
        removeTask(state, taskId) {
            Vue.delete(state.tasks, taskId);
        },
        resetState(state) {
            Vue.set(state, 'tasks', {});
        }
    },
    actions: {
        async setTask({ commit }, { callback, taskPayload }) {
            let notClearedForDispatch = store.getters['updateListeners/getWebsocketUpdateRequired'];
            if(notClearedForDispatch == false) {
                return new Promise((resolve) => {
                    let taskId = generateTaskId();

                    commit('setTask', { taskId, callback, expiresAt: getExpiresIn15Minutes(), taskPayload });

                    resolve(taskId);
                });
            } else {
                store.dispatch('errorNotificationStore/setErrors', [{fieldName: 'Websocketverbindung', message: i18n.t('ModuleRegistry.groups.systemConfiguration.sentences.websocketConnectionLost')}]);
                store.dispatch('errorNotificationStore/showErrorNotification');
            }
        },
        async getAndRemoveTask({ state, commit }, taskId) {
            return new Promise((resolve, reject) => {

                let task = state.tasks[taskId];
                if (!task) { return reject(`No task with Id "${taskId}" found`) }

                commit('removeTask', taskId);
                resolve(task);
            });
        },
        removeTask({ state, commit }, taskId) {
            commit('removeTask', taskId);
        },
        async removeAllExpiredTasks({ state, commit }) {
            let now = new Date(Date.now());

            for (let [key, value] of Object.entries(state.tasks)) {
                if (new Date(value.expiresAt) <= now) {
                    commit('removeTask', key);
                }
            }
        },
        removeAllOpenTasks({ commit }) {
            commit('resetState');
        },
    },
    getters: {
        getTask: state => id => state.tasks[id],
    }
}
const allNonDigits = /[^0-9.]/g;

const generateTaskId = () => {
    let id = uuid().toString().replace(allNonDigits, '');
    return `MT${id}`;
}

const getExpiresIn15Minutes = () => {
    var expiredAt = new Date(Date.now());
    expiredAt.setMinutes(expiredAt.getMinutes() + 15);
    return expiredAt;
}